import React from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { routes } from '../../routes';
import { images } from '../../assets/images';
// import { Link, NavLink } from 'react-router-dom';

class Footer extends React.Component {
    render() {
        return (
            <div className="footer_section">
                <Container>
                    <Row>
                        <Col>
                            <div className="footer_area">
                                <Row>
                                    <Col xl={3} lg={{ span: 3, order: 1 }} md={6} sm={12} xs={12}>
                                        <div className="footer_item">
                                            <div className="footer_title">
                                                <h4>Contact Info</h4>
                                            </div>
                                            <div className="contact_info">
                                                <ul>
                                                    <li>
                                                        <i className="fal fa-map-marker-alt"></i>
                                                        <div>
                                                            <Link to={{ pathname: "https://goo.gl/maps/Zef32RjAP1RbV3DE7" }} target="_blank">
                                                                Tech Cruizers Private Limited <br />
                                                                #123, Lorem ipsum Location, City, State, Country - 123456
                                                            </Link>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <i className="fal fa-phone-alt"></i>
                                                        <div>
                                                            <Link to={{ pathname: "https://goo.gl/maps/Zef32RjAP1RbV3DE7" }}>
                                                                +91-8968628088
                                                            </Link>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <i className="fal fa-phone-alt"></i>
                                                        <div>
                                                            <Link to={{ pathname: "https://goo.gl/maps/Zef32RjAP1RbV3DE7" }}>
                                                                +91-8054964656
                                                            </Link>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <i className="fal fa-envelope"></i>
                                                        <div>
                                                            <Link to={{ pathname: "https://goo.gl/maps/Zef32RjAP1RbV3DE7" }}>
                                                                info@techcruizer.com
                                                            </Link>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xl={3} lg={{ span: 3, order: 3 }} md={6} sm={12} xs={12}>
                                        <div className="footer_item">
                                            <div className="footer_title">
                                                <h4>Newsletter</h4>
                                            </div>
                                            <div className="newsletter_form">
                                                <Form>
                                                    <Form.Group controlId="exampleForm.ControlInput1">
                                                        <Form.Control type="email" placeholder="Enter Your E-mail" />
                                                    </Form.Group>
                                                    <div className="secondary_btn">
                                                        <Button type="submit">Subscribe</Button>
                                                    </div>
                                                </Form>
                                            </div>
                                            <div className="footer_title mb-3">
                                                <h4>Follow Us</h4>
                                            </div>
                                            <div className="social_icons">
                                                <ul className="list-inline">
                                                    <li>
                                                        <Link to={{ pathname: "https://www.facebook.com/" }} target="_blank">
                                                            <i className="fab fa-facebook-f"></i>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to={{ pathname: "https://www.twitter.com" }} target="_blank">
                                                            <i className="fab fa-twitter"></i>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to={{ pathname: "https://in.linkedin.com/" }} target="_blank">
                                                            <i className="fab fa-linkedin-in"></i>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to={{ pathname: "https://www.youtube.com/" }} target="_blank">
                                                            <i className="fab fa-youtube"></i>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to={{ pathname: "https://www.blogger.com/" }} target="_blank">
                                                            <i className="fab fa-blogger"></i>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to={{ pathname: "https://www.google.com" }} target="_blank">
                                                            <i className="fab fa-google-plus-g"></i>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to={{ pathname: "https://telegram.org/" }} target="_blank">
                                                            <i className="fab fa-telegram-plane"></i>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to={{ pathname: "https://web.skype.com" }} target="_blank">
                                                            <i className="fab fa-skype"></i>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to={{ pathname: "https://www.google.com" }} target="_blank">
                                                            <i className="fas fa-rss"></i>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to={{ pathname: "https://web.whatsapp.com" }} target="_blank">
                                                            <i className="fab fa-whatsapp"></i>
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </div>

                                        </div>
                                    </Col>
                                    <Col xl={6} lg={{ span: 6, order: 2 }} md={12} sm={12} xs={12}>
                                        <div className="footer_item">
                                            <div className="footer_title">
                                                <h4>Quick Links</h4>
                                            </div>
                                            <div className="quick_links">
                                                <ul className="list-unstyled">
                                                    <li>
                                                        <Link to={routes.index}>Home</Link>
                                                    </li>
                                                    <li>
                                                        <Link to={routes.about}>About Us</Link>
                                                    </li>
                                                    <li>
                                                        <Link to={routes.service}>Services</Link>
                                                    </li>
                                                    <li>
                                                        <Link to={routes.index}>Products</Link>
                                                    </li>
                                                    <li>
                                                        <Link to={routes.index}>Technologies</Link>
                                                    </li>
                                                    <li>
                                                        <Link to={routes.verticals}>Verticals</Link>
                                                    </li>
                                                    <li>
                                                        <Link to={routes.news}>News &amp; Events</Link>
                                                    </li>
                                                    <li>
                                                        <Link to={routes.hire}>Hire Resources</Link>
                                                    </li>
                                                    <li>
                                                        <Link to={routes.career}>Careers</Link>
                                                    </li>
                                                    <li>
                                                        <Link to={routes.faq}>FAQs</Link>
                                                    </li>
                                                    <li>
                                                        <Link to={routes.contact}>Contact Us</Link>
                                                    </li>
                                                    <li>
                                                        <Link to={routes.contact}>Sitemap</Link>
                                                    </li>
                                                    <li>
                                                        <Link to={routes.feedback}>Feedback</Link>
                                                    </li>
                                                    <li>
                                                        <Link to={routes.index}>Partner with us</Link>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <hr className="footer_separator" />
                            <div className="copyright_area">
                                <Row className="align-items-center">
                                    <Col xl={4} lg={{span: 4, order: 2}} md={12} sm={12} xs={12}>
                                        <div className="payment_options">
                                            <ul className="list-inline">
                                                <li>
                                                    <img src={images.payOption1} alt="..." />
                                                </li>
                                                <li>
                                                    <img src={images.payOption2} alt="..." />
                                                </li>
                                                <li>
                                                    <img src={images.payOption3} alt="..." />
                                                </li>
                                                <li>
                                                    <img src={images.payOption4} alt="..." />
                                                </li>
                                            </ul>
                                        </div>
                                    </Col>
                                    <Col xl={8} lg={{span: 8, order: 1}} md={12} sm={12} xs={12}>
                                        <ul className="list-inline copyright_line">
                                            <li><i className="fal fa-copyright"></i> Copyright 2021</li>
                                            <li>All Rights Reserved</li>
                                            <li>Powered by <Link to={{pathname: "https://globiztechnology.com/"}} target="_blank">Globiz Technology Inc.</Link></li>
                                        </ul>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default Footer;
